import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  APP_BACKGROUND_COLOR,
  APP_COLOR,
  APP_HOVER_COLOR,
  FONT_FAMILY,
  TEXT_COLOR,
} from "../../theme";

export const TransactionBody = styled(Box)(({ theme }) => ({
  boxShadow: "0px 0px 40px rgba(0, 0, 0, 0.8)",
  margin: "0px 50px 30px 50px",
  padding: "0.4rem 0.55rem 0.55rem 0.55rem",
  borderRadius: 5,
  color: "white",
  [theme.breakpoints.down("md")]: {
    margin: "20px",
    padding: 0,
  },
  [theme.breakpoints.down("sm")]: {
    margin: "10px",
    padding: 0,
  },
}));

export const WalletBody = styled(Box)(({ theme }) => ({
  boxShadow: "0px 0px 40px rgba(0, 0, 0, 0.8)",
  margin: "0px 0px 50px 50px",
  padding: "15px",
  display: "flex",
  width: "440px",
  borderRadius: "8px",
  color: TEXT_COLOR,
  [theme.breakpoints.down("sm")]: {
    margin: "10px",
    padding: 0,
    width: "auto",
  },
}));

export const NoEarningsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  color: TEXT_COLOR,
  [theme.breakpoints.down("sm")]: {
    justifyContent: "left",
    padding: "0 0 10px 25vw",
  },
}));

export const FixedTitleContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    color: "white",
    position: "sticky",
    zIndex: 4,
    paddingLeft: "80px",
    paddingRight: "80px",
    backgroundColor: APP_BACKGROUND_COLOR,
    display: "flex",
    left: -1,
    width: "180px",
    height: "20px",
    justifyConent: "center",
    alignItems: "center",
  },
}));

export const styles = {
  headingContainer: {
    display: "flex",
    justifyContent: "center",
    margin: "20px",
  } as const,
  rowContainer: {
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    flexDirection: "row",
    color: "white",
  } as const,
  formHeaderText: {
    width: "20%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "white",
  } as const,
  openSeaImage: {
    width: 20,
    marginLeft: 5,
    color: "white",
  } as const,
  hr: {
    color: "white",
    border: "1px solid white",
  } as const,
  myNftTable: {
    display: "grid",
    gridTemplateColumns: "repeat(6,1fr)",
    alignItems: "center",
    textAlign: "center",
    color: TEXT_COLOR,
  } as const,
  collaboratedNFTsTable: {
    display: "grid",
    gridTemplateColumns: "repeat(8,1fr)",
    alignItems: "center",
    textAlign: "center",
    color: TEXT_COLOR,
  } as const,
  FixedTitleValue: {
    color: TEXT_COLOR,
    position: "sticky",
    zIndex: 4,
    display: "block",
    left: -1,
    fontFamily:FONT_FAMILY,
    width: "180px",
  } as const,
  titleContainer: {
    margin: "20px",
    textAlign: "center",
    marginTop: "60px",
  } as const,
  openSeaImg: {
    width: 20,
    marginLeft: 5,
    color: TEXT_COLOR,
  } as const,
  ethereumImg: {
    width: 17,
    marginLeft: 5,
    backgroundColor: TEXT_COLOR,
  } as const,
  ethereumImgContainer: {
    width: 17,
    marginLeft: 5,
    backgroundColor: TEXT_COLOR,
  } as const,
};

export const walletDetailsStyles = {
  WithdrawBalanceButton: {
    textTransform: "none",
    fontFamily:FONT_FAMILY,
    color: "black",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
    paddingY: 1.5,
  } as const,
  WithdrawBalanceTypography: {
    fontFamily: FONT_FAMILY,
    fontSize: 20,
    fontWeight: "bold",
  },
};
